import React from 'react';
import { connect } from 'react-redux';

import { Row, Col, Divider, Checkbox, Skeleton, Space, Typography, Input, Slider, theme, Button, ConfigProvider } from 'antd';
// import { CaretRightOutlined, CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { setFilterCoverageDispatchAction, setFilterCompanyDispatchAction, resetFilters, setFilterPremiumStart, setFilterPremiumEnd, setFilterSortBy } from 'Redux/actions/comparationQuotationActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort } from '@fortawesome/free-solid-svg-icons';
import { SelectPlus } from 'Components/SelectPlus';
import { FilterGroupField } from '@shared/components/FiltersToolbar/FilterGroupField';
import { formatCurrency } from 'Utils/numberUtils';
import { getPaymentData } from '../InsurancePackageCard';
import './styles.css'

const { Text } = Typography

const LeftSidebar = (props) => {
  const {
    loading,
    aseguradoras,
    filters,
    coverages,
    minPackagePremium,
    maxPackagePremium,
    setFilterCoverageDispatchAction,
    setFilterCompanyDispatchAction,
    setFilterPremiumStart,
    setFilterPremiumEnd,
    setFilterSortBy,
    resetFilters,
    // insuranceCarriersErrors = [],
    // insuranceCarriersAlerts = [],
    // insuranceCarriersDataDifferences = [],
  } = props;
  const { token: themeToken } = theme.useToken();

  if (loading) return (
    <Row gutter={[0, 32]}>
      <Skeleton active paragraph={{ rows: aseguradoras?.length ?? 3 }} />
      <Skeleton active />
    </Row>
  );

  const handleChangeCheckCompany = (e) => setFilterCompanyDispatchAction(e.target.value);
  const handleChangeCheckCoverage = (e) => setFilterCoverageDispatchAction(e.target.value);
  const handleChangePremiumStart = (value) => setFilterPremiumStart(value);
  const handleChangePremiumEnd = (value) => setFilterPremiumEnd(value);
  const handleChangeSortBy = (value) => setFilterSortBy(value);

  const handleReset = () => {
    resetFilters();
  }
  // // Se verifica si hay notificaciones para mostrar
  // const hasNotifications = !!(insuranceCarriersErrors.length || insuranceCarriersAlerts.length || insuranceCarriersDataDifferences.length);

  const sortByOptions = [
    { label: <Text>Aseguradora <Text type='secondary' style={{ fontSize: '0.9em' }}>(A-Z)</Text></Text>, value: 'insuranceCarrier_asc' },
    { label: <Text>Aseguradora <Text type='secondary' style={{ fontSize: '0.9em' }}>(Z-A)</Text></Text>, value: 'insuranceCarrier_desc' },
    { label: <Text>Valor prima <Text type='secondary' style={{ fontSize: '0.9em' }}>(menor a mayor)</Text></Text>, value: 'premium_asc' },
    { label: <Text>Valor prima <Text type='secondary' style={{ fontSize: '0.9em' }}>(mayor a menor)</Text></Text>, value: 'premium_desc' },
  ]

  return (
    <Row style={{ borderRight: `1px solid ${themeToken.colorBorderSecondary}`, paddingRight: 16 }}>
      {/* {hasNotifications && (
        <Col span={24}>
          <Collapse
            className='collapse-notifications'
            defaultActiveKey={['3']}
            expandIconPosition='end'
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ margin: 0 }} />}
          >
            {insuranceCarriersErrors.length && (
              <Collapse.Panel
                key="1"
                className='collapse-panel-errors'
                header={
                  <Space className='header-space'>
                    <CloseCircleFilled className='icon-error' />
                    <Text>Errores: {insuranceCarriersErrors.length}</Text>
                  </Space>
                }
              >
                <Space direction='vertical'>
                  {insuranceCarriersErrors.map((item, index) => (
                    <Alert
                      key={index}
                      message={item.title}
                      description={item.description}
                    />
                  ))}
                </Space>
              </Collapse.Panel>
            )}
            {insuranceCarriersAlerts.length && (
              <Collapse.Panel
                key="2"
                className='collapse-panel-alerts'
                header={
                  <Space className='header-space'>
                    <ExclamationCircleFilled className='icon-alert' />
                    <Text>Alertas: {insuranceCarriersAlerts.length}</Text>
                  </Space>
                }
              >
                <Space direction='vertical'>
                  {insuranceCarriersAlerts.map((item, index) => (
                    <Alert
                      key={index}
                      message={item.title}
                      description={item.description}
                    />
                  ))}
                </Space>
              </Collapse.Panel>
            )}
            {insuranceCarriersDataDifferences.length && (
              <Collapse.Panel
                key="3"
                className='collapse-panel-inconsistencies'
                header={
                  <Space className='header-space'>
                    <ExclamationCircleFilled className='icon-inconsistency' />
                    <Text>Inconsistencias: {insuranceCarriersDataDifferences.length}</Text>
                  </Space>
                }
              >
                <Space direction='vertical'>
                  {insuranceCarriersDataDifferences.map((item, index) => (
                    <Alert
                      key={index}
                      message={item.title}
                      description={item.description}
                    />
                  ))}
                </Space>
              </Collapse.Panel>
            )}
          </Collapse>
        </Col>
      )} */}
      <Col span={24} style={{ marginBottom: '12px' }}>
        <Space direction='vertical' style={{ width: '100%' }}>
          <Space>
            <FontAwesomeIcon icon={faSort} color={themeToken.colorPrimary} />
            <Text strong style={{ fontSize: '1.1em', color: themeToken.colorPrimary }}>Ordenar por</Text>
          </Space>
          <SelectPlus value={filters.sortBy} style={{ width: '100%' }} options={sortByOptions} onChange={handleChangeSortBy} />
        </Space>
      </Col>
      <Divider size='middle' />
      <Col span={24}>
        <Row gutter={[0, 16]}>
          <Space>
            <FontAwesomeIcon icon={faFilter} color={themeToken.colorPrimary} />
            <Text strong style={{ fontSize: '1.1em', color: themeToken.colorPrimary }}>Filtros</Text>
          </Space>
          <Col span={24}>
            <Text strong style={{ color: themeToken.colorPrimary }}>Valor prima</Text>
            <Slider
              range
              value={[filters.premiumStart ?? minPackagePremium, filters.premiumEnd ?? maxPackagePremium]}
              min={minPackagePremium}
              max={maxPackagePremium}
              defaultValue={[minPackagePremium, maxPackagePremium]}
              tooltip={{ formatter: (value) => formatCurrency(value) }}
              onChange={([min, max]) => {
                handleChangePremiumStart(min);
                handleChangePremiumEnd(max);
              }}
            />
            <FilterGroupField
              items={[
                {
                  label: 'Mínimo',
                  component: <Input disabled value={formatCurrency(filters.premiumStart ?? minPackagePremium)} />,
                },
                {
                  label: 'Máximo',
                  component: <Input disabled value={formatCurrency(filters.premiumEnd ?? maxPackagePremium)} />,
                },
              ]}
            />
          </Col>
          <Col span={24}>
            <Space direction='vertical'>
              <Text strong style={{ color: themeToken.colorPrimary }}>Aseguradoras</Text>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {aseguradoras.map((insuranceCarrier) => (
                  <li key={insuranceCarrier.id} style={{ marginBottom: '5px' }}>
                    <ConfigProvider theme={{ token: { colorBorder: themeToken.colorPrimary } }} >
                      <Checkbox
                        onChange={handleChangeCheckCompany}
                        checked={filters.selectedInsuranceCarriers.includes(insuranceCarrier.id)}
                        // disabled={insuranceCarrier.disabled}
                        value={insuranceCarrier.id}
                      >
                        {insuranceCarrier.name}
                        {/* {insuranceCarrier.messageError && (
                  <Tooltip title={insuranceCarrier.messageError}>
                  <FontAwesomeIcon icon={faExclamation} style={{ color: 'red' }} />
                  </Tooltip>
                  )} */}
                        {/* {insuranceCarrier.loading && <Spin style={{ marginLeft: '4px' }} />} */}
                      </Checkbox>
                    </ConfigProvider>
                  </li>
                ))}
              </ul>
            </Space>
          </Col>
          <Col span={24}>
            <Space direction='vertical'>
              <Text strong style={{ color: themeToken.colorPrimary }}>Coberturas</Text>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {
                  coverages.filter(((item) => item.main)).map((coverage) => {
                    return (
                      <li style={{ listStyle: 'none', padding: 0, marginBottom: '5px' }} key={coverage.id}>
                        <ConfigProvider theme={{ token: { colorBorder: themeToken.colorPrimary } }} >
                          <Checkbox
                            onChange={handleChangeCheckCoverage}
                            value={coverage.id}
                            checked={filters.selectedCoverage.includes(coverage.id)}
                          >
                            &nbsp;&nbsp;
                            <span>{coverage.name}</span>
                            &nbsp;&nbsp;
                          </Checkbox>
                        </ConfigProvider>
                      </li>
                    );
                  })
                }
              </ul>
            </Space>
          </Col>
          {/* <Divider size='middle' /> */}
          <Button type='primary' ghost onClick={handleReset}>Limpiar filtros</Button>
        </Row>
      </Col>
    </Row>
  );
};

const actions = {
  setFilterCoverageDispatchAction,
  setFilterCompanyDispatchAction,
  setFilterPremiumStart,
  setFilterPremiumEnd,
  setFilterSortBy,
  resetFilters,
};

const mapStateToProps = (state) => {
  const { packages, inactivePackages } = state.globalQuotation.quotation;
  const allPackages = [...packages, ...inactivePackages];
  const minPackagePremium = Math.min(...allPackages.map((paquete) => getPaymentData(paquete)?.value ?? 0));
  const maxPackagePremium = Math.max(...allPackages.map((paquete) => getPaymentData(paquete)?.value ?? 0));

  return {
    minPackagePremium,
    maxPackagePremium,
    aseguradoras: state.initialData.aseguradoras,
    filters: state.comparationQuotation.filters,
    coverages: state.globalQuotation.quotation.coverages,
  }
};

export default connect(mapStateToProps, actions)(LeftSidebar);